// src/pages/GuestLoginPage.jsx
import { useState, useEffect } from "react";
import { Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { confirmAppointment } from "../../api/appointmentService";
import { useParams } from "react-router-dom";

const AppointmentConfirmPage = () => {
  const { t } = useTranslation("common");
  const { code } = useParams();
  const [message, setMessage] = useState(t('appointments.public.messages.wait'));
  const [imgUrl, setImgUrl] = useState("/images/new_patient.png");

  const handleConfirm = async () => {
    try {
      await confirmAppointment(code);
      setMessage(t('appointments.public.messages.confirm_success'));
      setImgUrl("/images/new_patient.png");
    } catch (error) {
      switch (error.status) {
        case 410:
        case 411:
        case 414:
          setMessage(t('appointments.public.messages.invalid_confirm_link'));
          setImgUrl("/images/sad_dog.png");
          break;
        case 412:
          setMessage(t('appointments.public.messages.confirm_link_expired'));
          setImgUrl("/images/sad_dog.png");
          break;
        case 413:
          setMessage(t('appointments.public.messages.appointment_previously_confirmed'));
          setImgUrl("/images/new_patient.png");
          break;
        default:
          setMessage(t('appointments.public.messages.invalid_confirm_link'));
          setImgUrl("/images/sad_dog.png");
      }
    }
  };

  useEffect(() => {
    handleConfirm();
  }, []);

  return (
    <>
        <Box
            component="img"
            src={imgUrl}
            alt="Patient"
            sx={{ width: "100%", height: "auto", borderRadius: 3 }}
        />
        <Typography variant="h4" sx={{ flexGrow: 1, marginBottom: "1rem" }}>
            {message} 
        </Typography>
    </>
  );
};

export default AppointmentConfirmPage;